export function isValidURL(url) {
    const regex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/\S*)?$/;
    return regex.test(url);
}

export const convertToFormData = (obj) => {

    const formData = new FormData()

    for (let key in obj) {

        formData.append(key, obj[key])

    }

    return formData

}

export const formatContent = (text) => {
    // Replace newlines with <br>
    let formatted = text.replace(/\n/g, '<br/>');

    // Optional: Bold **text**
    formatted = formatted.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

    // Optional: Italic *text*
    formatted = formatted.replace(/\*(.*?)\*/g, '<em>$1</em>');

    return formatted;
};

export const handleValidation = (value, type = 'Required', key, val, setValidation, min = 0, mac = 0, regex,) => {


    if (type === 'Required' && !value) {


        setValidation(prev => ({
            ...prev,
            [key]: val
        }))

    }


}

export const parseQuestions = (text) => {
    const questionBlocks = text.split(/\*\*\d+\./).slice(1); // Remove intro
    const result = [];

    for (const block of questionBlocks) {
        const [qTextRaw, ...optionsRaw] = block.trim().split(/\n/);
        const q = qTextRaw.trim().replace(/\*\*/g, '');

        const options = optionsRaw
            .filter(line => /^[A-D]\)/.test(line.trim()))
            .map(line => line.replace(/^[A-D]\)\s*/, '').trim());

        result.push({ q, options });
    }

    return result;
};

export function arraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    const sorted1 = [...arr1].sort();
    const sorted2 = [...arr2].sort();

    return sorted1.every((val, index) => val === sorted2[index]);
}

export function getTimeDifference(startTime, endTime) {
    // Convert start and end times to Date objects
    const [startHours, startMinutes, startSeconds] = startTime.split(':').map(Number);
    const [endHours, endMinutes, endSeconds] = endTime.split(':').map(Number);

    // Create Date objects for the current day
    const startDate = new Date();
    startDate.setHours(startHours, startMinutes, startSeconds, 0);

    const endDate = new Date();
    endDate.setHours(endHours, endMinutes, endSeconds, 0);

    // Calculate the difference in milliseconds
    let diffMs = endDate - startDate;

    // Handle negative difference (if end time is past midnight)
    if (diffMs < 0) {
        diffMs += 24 * 60 * 60 * 1000; // Add 24 hours
    }

    // Convert milliseconds to hours, minutes, and seconds
    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);

    return { hours, minutes, seconds };
}


export function formatDate(date) {
    if (!date) return "-";

    return new Date(date).toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    });
}

